import React from 'react';
import { useDispatch } from 'react-redux';

import { Page } from 'ui/components';
import { formatDate, currencyFormat } from 'utilities/common';

import { Report } from 'services/action';
import Overdue from './component/overude';
import Outstanding from './component/outstanding';

const initialState = {
  filter: {
    date: new Date(),
    format: formatDate(new Date(), 'YYYY'),
  },
  isLoading: false,
  data: null,
};

const ReportOutstanding = () => {
  const Dispatch = useDispatch();
  const [{ data, filter }, setState, ] = React.useState(initialState);

  const $onLoad = async() => {
    const params = {
      yearly: filter?.format,
    }
    const result = await Dispatch(Report.$outstanding(params));
    if (result?.message === 'success') {
      setState((prevState) => ({
        ...prevState,
        data: result?.data
      }));
    }
  }

  React.useEffect(() => {
    $onLoad();
  }, [filter]);

  return (
    <Page className="fixed">
      <Page.Header title="Laporan Outstanding"  />

      <div className="row p-2 justify-content-center">
        <div className="col-2 mb-1 mb-md-0">
          <div className="rounded-2 border bg-light-lt text-center p-2">
            <div className="fs-5 fw-semibold text-left text-secondary">
              {currencyFormat(data?.summary?.subtotal_outstanding || 0)}
            </div>
            <div className="page-pretitle text-secondary">Outstanding</div>
          </div>
        </div>
        <div className="col-2 mb-1 mb-md-0">
          <div className="rounded-2 border bg-light-lt text-center p-2">
            <div className="fs-5 fw-semibold text-left text-secondary">
              {currencyFormat(data?.summary?.total_outstanding_overdue || 0)}
            </div>
            <div className="page-pretitle text-primary">Total Overdue</div>
          </div>
        </div>
        <div className="col-2 mb-1 mb-md-0">
          <div className="rounded-2 border bg-light-lt text-center p-2">
            <div className="fs-5 fw-semibold text-left text-secondary">
              {currencyFormat(data?.summary?.subtotal_outstanding_overdue || 0)}
            </div>
            <div className="page-pretitle text-warning">Nominal Overdue</div>
          </div>
        </div>
      </div>


      <Page.Body className="row">
        <div className='col-6 border-end'>
          <Outstanding data={data?.outstanding}/>
        </div>
        <div className='col-6'>
          <Overdue data={data?.overdue}/>
        </div>
      </Page.Body>
    </Page>
  );
};

export default ReportOutstanding;
